import { render, staticRenderFns } from "./bouton.vue?vue&type=template&id=4057d069&scoped=true"
import script from "./bouton.vue?vue&type=script&lang=js"
export * from "./bouton.vue?vue&type=script&lang=js"
import style0 from "./bouton.vue?vue&type=style&index=0&id=4057d069&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4057d069",
  null
  
)

export default component.exports